import { Box, Button, ButtonProps, Typography } from "@mui/material";
import {
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";
import { ReactNode } from "react";
import { RiskFactorStats } from "~/operations";
import { createRiskFactorSectionTitle } from "~/pages/space/security/components/RiskFactors/utils";

export type RiskFactorsTitle = {
  id?: string;
  open: boolean;
  onClick: ButtonProps["onClick"];
  riskFactors?:
    | (
        | (RiskFactorStats & {
            description: { active: string; inactive: string };
          })
        | null
      )[]
    | null
    | undefined;
  showSubtitle?: boolean;
  hideValues?: boolean;
  suffix?: ReactNode;
  title: string;
  icon: ReactNode;
};

export function RiskFactorsTitle({
  id,
  open,
  onClick,
  riskFactors,
  showSubtitle,
  suffix,
  hideValues,
  title,
  icon,
}: RiskFactorsTitle) {
  const subtitle = createRiskFactorSectionTitle(riskFactors, { hideValues });

  return (
    <Box
      id={id}
      display="flex"
      alignItems="flex-start"
      justifyContent="space-between"
    >
      <Box>
        <Button
          className="toggle"
          variant="text"
          endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          onClick={onClick}
          sx={{
            textAlign: "left",
            ml: -0.5,
            p: 0.5,
            ".MuiButton-endIcon": { color: "primary.main" },
          }}
        >
          <Typography textTransform="uppercase" fontWeight={700}>
            {title}
          </Typography>
        </Button>

        {showSubtitle && subtitle && (
          <Box className="subtitle">
            <Typography color="text.secondary" fontSize="14px">
              {subtitle}
            </Typography>
          </Box>
        )}
      </Box>

      {suffix && (
        <Box className="suffix" ml="auto">
          {suffix}
        </Box>
      )}

      {icon}
    </Box>
  );
}
